import React, { useEffect, useState } from "react";
import { VertexGroupsEditor } from "./VertexGroupsEditor";
import { SelectedVerticesStats } from "./SelectedVerticesStats";
import { useEditorState } from "@/state/editorState";
import { ModelStats } from "./ModelStats";
import { ResizeTest } from "./ResizeTest";
import { ElementEditor } from "./ElementEditor";
import { AreaEditor } from "./AreaEditor";
import { ElementInstanceTest } from "./ElementInstanceTest";
import { MaterialEditor } from "./Materials/MaterialEditor";

import css from "./EditorToolsColumn.module.css";

import cn from "classnames";
import { MeshGroupsEditor } from "./MeshGroups/MeshGroupsEditor";
import { FileManagement } from "./FileManagement";

export const EditorToolsColumn = () => {
    const [tab, setTab] = useState<
        "vertexGroups" | "elementEditor" | "materialEditor" | "meshGroups" | "fileManagement"
    >("fileManagement");
    const setRenderVertices = useEditorState((state) => state.setRenderVertices);

    const model = useEditorState((state) => state.model);

    useEffect(() => {
        setRenderVertices(tab === "vertexGroups");
    }, [tab]);

    if (!model) {
        return <FileManagement />;
    }

    return (
        <div className="d-flex flex-row flex-grow-1 position-relative h-100">
            <div className={css.navigationContainer}>
                <ul className={cn(css.navigation, "nav nav-tabs")}>
                    <li className="nav-item">
                        <a
                            className={`nav-link ${tab === "vertexGroups" ? "active" : ""}`}
                            aria-current="page"
                            href="#"
                            onClick={() => setTab("vertexGroups")}
                        >
                            Vertex Groups
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className={`nav-link ${tab === "elementEditor" ? "active" : ""}`}
                            href="#"
                            onClick={() => setTab("elementEditor")}
                        >
                            Elements
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className={`nav-link ${tab === "materialEditor" ? "active" : ""}`}
                            href="#"
                            onClick={() => setTab("materialEditor")}
                        >
                            Materials
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className={`nav-link ${tab === "meshGroups" ? "active" : ""}`}
                            href="#"
                            onClick={() => setTab("meshGroups")}
                        >
                            Mesh Groups
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className={`nav-link ${tab === "fileManagement" ? "active" : ""}`}
                            href="#"
                            onClick={() => setTab("fileManagement")}
                        >
                            File Management
                        </a>
                    </li>
                </ul>
            </div>
            <div className="d-flex flex-column flex-grow-1 overflow-auto">
                {tab === "vertexGroups" && (
                    <div className="border-start flex-grow-1 p-2 fs-6">
                        <ModelStats model={model} />
                        <SelectedVerticesStats />
                        <VertexGroupsEditor />
                        <ResizeTest />
                    </div>
                )}
                {tab === "elementEditor" && (
                    <div className="border-start flex-grow-1 p-2 fs-6">
                        <AreaEditor />
                        <ElementEditor />
                        <ElementInstanceTest />
                    </div>
                )}
                {tab === "materialEditor" && (
                    <div className="border-start flex-grow-1 p-2 fs-6">
                        <MaterialEditor />
                    </div>
                )}
                {tab === "meshGroups" && (
                    <div className="border-start flex-grow-1 p-2 fs-6">
                        <MeshGroupsEditor />
                    </div>
                )}
                {tab === "fileManagement" && (
                    <div className="border-start flex-grow-1 p-2 fs-6">
                        <FileManagement />
                    </div>
                )}
            </div>
        </div>
    );
};
